import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-arrow-right',
    templateUrl: './arrow-right.component.svg',
    styleUrls: ['./arrow-right.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowRightComponent {}
